import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { var_api } from "../../../constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const WarehouseCustomerMaster = () => {
  const tableHeaders = [
    "#",
    "Customer ",
    "Mobile",
    "DOB",
    "Anniversary",
    "Address",
    // "Veezzo Customer",
    "Remarks",
  ];

  const [customerData, setCustomerData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    warehouse_id: 1,
    customer_name: "",
    customer_mobile_whatsapp: "",
    customer_dob: "",
    anniversary: "",
    full_address: "",
    is_veezzo_customer: 0,
    remarks: "",
    // is_active: 1,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 250;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchCustomerData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };
// ✅ Convert date to dd-mm-yyyy format for table display
const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

  const fetchCustomerData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_instore_customers/get`);
      setCustomerData(res.data || []);
    } catch {
      toast.error("Failed to fetch customer data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleAddClick = () => {
    setFormData({
      warehouse_id: 1,
      customer_name: "",
      customer_mobile_whatsapp: "",
     customer_dob:"" ,
  anniversary: "",
      full_address: "",
      is_veezzo_customer: 0,
      remarks: "",
    //   is_active: 1,
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.customer_name.trim())
      newErrors.customer_name = "Customer name is required";
  if (!formData.customer_mobile_whatsapp.trim()) {
  newErrors.customer_mobile_whatsapp = "Mobile number is required";
} else if (!/^\d{10}$/.test(formData.customer_mobile_whatsapp.trim())) {
  newErrors.customer_mobile_whatsapp = "Mobile number must be exactly 10 digits";
}

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }
// ✅ Convert date to DD-MM-YYYY format



    try {
      setLoading(true);
const payload = {
  ...formData,
 
};

      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(
          `${var_api}veemart_instore_customers/update/${formData.id}`,
          payload
        );
      } else {
        res = await axios.post(
          `${var_api}veemart_instore_customers/post`,
          payload
        );
      }

      toast.success(res?.data?.message || "Customer saved successfully!");
      setShowModal(false);
      fetchCustomerData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save customer");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = customerData.filter((item) =>
    Object.values(item).some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search customer..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                {/* <Button variant="secondary" onClick={handleAddClick}>
                  Add
                </Button> */}
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {tableHeaders.map((header, idx) => (
                        <th key={idx}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td
                          colSpan="10"
                          className="text-center text-muted py-3"
                        >
                          No data found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>{item.customer_name}</td>
                          <td>{item.customer_mobile_whatsapp}</td>
                         <td>{formatDisplayDate(item.customer_dob)}</td>
<td>{formatDisplayDate(item.anniversary)}</td>

                          <td>{item.full_address}</td>
                          {/* <td>
                            <span
                              className={`badge ${
                                item.is_veezzo_customer === 1
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.is_veezzo_customer === 1
                                ? "Yes"
                                : "No"}
                            </span>
                          </td> */}
                          <td>{item.remarks}</td>
                          {/* <td>
                            <span
                              className={`badge ${
                                item.is_active === 1
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {item.is_active === 1 ? "Active" : "Inactive"}
                            </span>
                          </td> */}
                          {/* <td className="text-center">
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{
                                backgroundColor: "#007bff",
                                color: "white",
                              }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td> */}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={
                        currentPage === idx + 1 ? "primary" : "light"
                      }
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditMode ? "Edit Customer" : "Add Customer"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Customer Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="customer_name"
                      value={formData.customer_name}
                      placeholder="Enter customer name"
                      onChange={handleInputChange}
                    />
                    {errors.customer_name && (
                      <div className="text-danger small mt-1">
                        {errors.customer_name}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Mobile / WhatsApp <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="customer_mobile_whatsapp"
                      value={formData.customer_mobile_whatsapp}
                      placeholder="Enter mobile number"
                      onChange={handleInputChange}
                    />
                    {errors.customer_mobile_whatsapp && (
                      <div className="text-danger small mt-1">
                        {errors.customer_mobile_whatsapp}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      name="customer_dob"
                      value={formData.customer_dob}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Anniversary</Form.Label>
                    <Form.Control
                      type="date"
                      name="anniversary"
                      value={formData.anniversary}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Full Address</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="full_address"
                      value={formData.full_address}
                      placeholder="Enter full address"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

              

                {/* {isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-3 d-flex align-items-center gap-2">
                      <Form.Label className="mb-0">Status</Form.Label>
                      <Form.Check
                        type="switch"
                        id="status-switch"
                        checked={formData.is_active === 1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_active: e.target.checked ? 1 : 0,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                )} */}

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      type="text"
                      name="remarks"
                      value={formData.remarks}
                      placeholder="Enter remarks"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                  {/* <Col md={6}>
                  <Form.Group className="mb-3 d-flex align-items-center gap-2">
                    <Form.Check
                      type="switch"
                      id="veezzo-switch"
                      label="Is Veezzo Customer"
                      checked={formData.is_veezzo_customer === 1}
                      onChange={handleInputChange}
                      name="is_veezzo_customer"
                    />
                  </Form.Group>
                </Col> */}
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                          warehouse_id: 1,
                          customer_name: "",
                          customer_mobile_whatsapp: "",
                          customer_dob: "",
                          anniversary: "",
                          full_address: "",
                          is_veezzo_customer: 0,
                          remarks: "",
                        //   is_active: 1,
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => setShowModal(false)}
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>
      <ToastContainer />
    </>
  );
};

export default WarehouseCustomerMaster;
